import "./style.css";
import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import { RectAreaLightUniformsLib } from "three/examples/jsm/lights/RectAreaLightUniformsLib";
// import { RectAreaLightHelper } from "three/examples/jsm/helpers/RectAreaLightHelper";
import gsap from "gsap";
import {
  CSS3DRenderer,
  CSS3DObject,
} from "three/examples/jsm/renderers/CSS3DRenderer";



/**
 * URLS
 */
const modelUrl = 'https://calcifer-3118.github.io/portfolio-website-build/model/untitled.glb';
const video_tableTennis = 'https://calcifer-3118.github.io/portfolio-website-build/videos/Table_Tennis.mp4';
const video_3dChess = 'https://calcifer-3118.github.io/portfolio-website-build/videos/3d-chess.mp4';
 



let scene_loaded = false;
const loadScene = ()=>{

  scene_loaded = true;

  /**
   * Base
   */
  // Canvas
  const canvas = document.querySelector("canvas.webgl");
  
  // Scene
  const scene = new THREE.Scene();
  scene.background = 0x333334;

  /**
   * Sizes
   */
  const sizes = {
    width: window.innerWidth,
    height: window.innerHeight,
  };

  window.addEventListener("resize", () => {
    // Update sizes
    sizes.width = window.innerWidth;
    sizes.height = window.innerHeight;

    // Update camera
    camera.aspect = sizes.width / sizes.height;
    camera.updateProjectionMatrix();

    // Update renderer
    renderer.setSize(sizes.width, sizes.height);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

    ui_renderer.setSize(sizes.width, sizes.height);
  });

  /**
   * Camera
   */
  // Base camera
  const camera = new THREE.PerspectiveCamera(
    75,
    sizes.width / sizes.height,
    0.1,
    100
  );
  camera.position.set(0, 5, -18);
  scene.add(camera);


  /**
   * Model
   */
  let model, actions, mixer;
  const loader = new GLTFLoader();
  let model_loaded = false;
  const player = document.getElementsByClassName('lottie-loading')[0];
  const text = document.getElementById('loading-text');

  const loadModel = (url) => {
    loader.load(url, (_model) => {
      model = _model.scene;

      _model.scene.rotateY(Math.PI);
      _model.scene.scale.set(3, 3, 3);
      _model.scene.position.set(0, 0, 3.5);

      _model.scene.castShadow = true;

      scene.add(_model.scene);

      mixer = new THREE.AnimationMixer(model);
      actions = {};
      _model.animations.forEach(function (clip) {
        var action = mixer.clipAction(clip);
        actions[clip.name] = action;
      });

      model_loaded = true;
      player.style.display = 'none';
      text.style.display = 'none';

      update()

    },

    (xhr) => {
      const total_size = 6263880;
      text.innerHTML = Math.round((xhr.loaded / total_size * 100)) + '%';
      player.seek((xhr.loaded / total_size * 100) + '%');
      player.play();
    }

    );
  };
  loadModel(modelUrl);


  function playAnimation(name) {
      if(name)
        actions[name].play();
  }
  
  function stopAnimation(name) {
    if(name)
      actions[name].stop();
  }

  function switchAnimation(name) {
    if(name){
      mixer.stopAllAction();
      actions[name].play();
    }
      
}


  let played = false;

  /**
   * Lighting
   */
  RectAreaLightUniformsLib.init();

  const rectLight1 = new THREE.RectAreaLight(0x92c0ea, 5, 16, 8);
  rectLight1.position.set(0, 5, 5);
  scene.add(rectLight1);

  const rectLight2 = new THREE.RectAreaLight(0xffffff, 0.8, 12, 5);
  rectLight2.rotateX(-Math.PI);
  rectLight2.position.set(0, 5, -1);
  scene.add(rectLight2);


  const geoFloor = new THREE.BoxGeometry(2000, 0.1, 100);
  const matStdFloor = new THREE.MeshStandardMaterial({
    color: 0x808080,
    roughness: 0.3,
    metalness: 0,
  });
  const mshStdFloor = new THREE.Mesh(geoFloor, matStdFloor);
  mshStdFloor.receiveShadow = true;
  scene.add(mshStdFloor);





  const plane_geo = new THREE.PlaneGeometry(16, 8)
  const plane = new THREE.Mesh(plane_geo, new THREE.MeshBasicMaterial({color:0x92c0ea}));
  plane.rotateX(Math.PI);
  plane.position.x = rectLight1.position.x;
  plane.position.y = rectLight1.position.y;
  plane.position.z = rectLight1.position.z + 0.1;
  scene.add(plane)

  



  /**
   * Renderer
   */
  const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    antialias: true,
  });
  renderer.setSize(sizes.width, sizes.height);
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
  renderer.outputEncoding = THREE.sRGBEncoding;


   const ui_renderer = new CSS3DRenderer();
   ui_renderer.domElement.style.position = 'absolute';
   ui_renderer.domElement.style = `   -webkit-user-select: none; /* Chrome/Safari */
   -moz-user-select: none; /* Firefox */
   -ms-user-select: none; /* Internet Explorer */
   user-select: none; /* Standard */`
   ui_renderer.setSize(window.innerWidth, window.innerHeight);
   document.body.appendChild(ui_renderer.domElement);


  // Controls
  const controls = new OrbitControls(camera, ui_renderer.domElement);
  controls.target.set(0, 4, 0);
  controls.maxDistance = 4;
  controls.minDistance = 3;
  controls.maxPolarAngle = Math.PI / 1.83;
  controls.minPolarAngle = Math.PI / 2.18;
  controls.maxAzimuthAngle = -Math.PI / 1.2;
  controls.minAzimuthAngle = Math.PI / 1.2;
  controls.enableDamping = true;
  controls.enablePan = false;
  // controls.enableRotate = false;
  controls.rotateSpeed = 0.2;
  controls.enableZoom = false;

  
    setTimeout(() => {
      if (model_loaded && !played) {
        mixer.timeScale = 0.6;
        playAnimation('namaste');
        mixer._actions[0].repetitions = 1;
        
        setTimeout(() => {
          gsap.to(model.position, { x: -8, duration: 1 });
          gsap.to(model.rotation, { y: Math.PI / 3 });
          
          setTimeout(() => {
            drawUI();
            played = true;
          }, 800);
        }, 3000);
      }
    }, 1500);

    
  const raycaster = new THREE.Raycaster();
  const pointer = new THREE.Vector2();
  window.addEventListener('mousemove', (event)=>{
    event.preventDefault();

    pointer.x = ( event.clientX / window.innerWidth ) * 2 - 1;
	  pointer.y = - ( event.clientY / window.innerHeight ) * 2 + 1;

    raycaster.setFromCamera( pointer, camera );

    let intersects;
    if(model){

      intersects = raycaster.intersectObjects( model.children[0].children );
      
     
      if (intersects.length > 0 && played ) {
        switchAnimation('wave');
      }
      else
      {
        mixer._actions[1].repetitions = 1;
      }
      
    }
      
  })  
  

  document.body.addEventListener("mousemove", (e) => {
    controls.handleMouseMoveRotate(e);
  });

 
 
const drawUI = () => {

    const container = document.createElement("div");
    container.innerHTML = `     
    <div class="scroll-container">
      
    <!-- Intro -->
    <section>
        <h1 class='title'>Hi! I'm Calcifer</h1>
        <lottie-player src="https://assets3.lottiefiles.com/packages/lf20_P4RBQZ.json"  background="transparent"  speed="1"  style="width: 60px; height: 60px; rotate: 270deg"  loop  autoplay></lottie-player>
    </section>
    <section>
         <h1 class='description'>A passionate Game Developer and Student</h1>
    </section>
   
    <!-- Work -->
    <section>
        <h1 class='links'>Work</h1>
    </section>   
    <section id='work-section'>
    <div class="container">

    <div class="card">
      <div class="box">
        <div class="content">
          <h3>CheeseSteaks in the Liberty Bell</h3>
          <p></p>
          <a href="https://calcifer-3118.itch.io/cheesesteaks-in-the-liberty-bell" target=_blank>Visit</a>
        </div>
      </div>
    </div>


      <div class="card">
      <div class="box">
        <div class="content">
          <h3>Table Tennis</h3>
            <p>A cool JavaScript game which runs in your browser and you can play it with your hands, I mean literally with hands not with mouse or keyboard.
              It uses a...</p>
            <a href="https://calcifer-3118.itch.io/table-tennis" target=_blank>Read More</a>
        </div>
      </div>
    </div>


    <div class="card">
      <div class="box">
        <div class="content">
          <h3>Interactive Portfolio</h3>
          <p>Check out my interactive portfolio made using Unity Engine...</p>
          <a href="#">Read More</a>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="box">
        <div class="content">
          <h3>Mocha</h3>
          <p></p>
          <a href="#">Read More</a>
        </div>
      </div>
    </div>


    <div class="card">
      <div class="box">
        <div class="content">
          <h3>3D Chess</h3>
          <p></p>
          <a href="https://github.com/calcifer-3118/3d-chess" target=_blank>Read More</a>
        </div>
      </div>
    </div>
  
    </div>
    </section>
   
    
    <!-- About -->
    <section>
      <h1 class='links'>About</h1>
    </section>  
    <section>
     
    </section>


    <!-- Contact -->
    <section>
      <h1 class='links'>Contact</h1>
    </section>
    <section>
    <div class="social-links">
      <a href="https://www.instagram.com/calcifer_3118/" target="_blank"><i class="fab fa-instagram"></i></a>
      <a href="https://discordapp.com/users/Calcifer#7817" target="_blank"><i class="fab fa-discord"></i></a>
      <a href="https://github.com/calcifer-3118" target="_blank"><i class="fab fa-github"></i></a>
      <a href="https://www.linkedin.com/in/dheer-jain/" target="_blank"><i class="fab fa-linkedin-in"></i></a>
    </div>

    </section>

  
</div> 
    `;


    const obj = new CSS3DObject(container);
    obj.rotateY(Math.PI);
    obj.position.z = 600;
    obj.position.y = 75;

    scene.add(obj);

    const scrollContainer = container.querySelector('.scroll-container');
    window.addEventListener('wheel', (e) => {


      const x_pos = Math.round(scrollContainer.scrollLeft / scrollContainer.clientWidth);
      const y_pos = scrollContainer.scrollTop / scrollContainer.clientHeight;


      const scrollLeft = () => {

        scrollContainer.style.overflowY = 'hidden';
        scrollContainer.style.overflowX = 'scroll';

        if (e.deltaY > 0)
          scrollContainer.scrollTo(scrollContainer.scrollLeft + (.69 * scrollContainer.clientWidth), 0);
        else if (e.deltaY <= 0) {
          scrollContainer.scrollTo(scrollContainer.scrollLeft - (.69 * scrollContainer.clientWidth), 0);
          if (x_pos <= 4 && x_pos > 2)
            scrollContainer.scrollTop = 3.47 * scrollContainer.clientHeight;
        }

      };

      const scrollTop = () => {
        scrollContainer.style.overflowX = 'hidden';
        scrollContainer.style.overflowY = 'scroll';


        if (e.deltaY > 0) {
          scrollContainer.scrollTo(scrollContainer.scrollLeft, scrollContainer.scrollTop + (0.3 * scrollContainer.clientHeight));
          if (y_pos >= 3.45)
            scrollLeft();
        }
        else if (e.deltaY <= 0) {
          scrollContainer.scrollTo(scrollContainer.scrollLeft, scrollContainer.scrollTop - (0.3 * scrollContainer.clientHeight));
          if (y_pos <= 0)
            scrollLeft();
        }

      };



      if (x_pos <= 2 || x_pos >= 4) {
        scrollLeft();
      }

      else if (x_pos > 2 && x_pos < 4) {
        scrollTop();
      }

    });

   


    

    //Video
    const video = document.getElementById( 'video' );
    const createVideoTex = (url)=>{
        video.src = url;
        const texture = new THREE.VideoTexture( video );
        texture.flipY = false;
        texture.wrapS = THREE.RepeatWrapping;
        texture.repeat.x = - 1;
        return texture;  
    }

    const assignVideoTexture = (url)=>{
        const texture = createVideoTex(url)
        video.play();
        plane.material.map = texture;
        plane.material.needsUpdate = true;
    }

    const playOnHover = (element_no, url)=>{
      const card = scrollContainer.getElementsByClassName('card')[element_no];
      card.addEventListener('mouseenter', ()=>{
          assignVideoTexture(url);
      })

      card.addEventListener('touchstart', ()=> assignVideoTexture(url));
      document.body.addEventListener('touchstart', ()=> {
        video.pause();
        plane.material.color.set(0x92c0ea)
        plane.material.map = null;
        plane.material.needsUpdate = true;
      })

      card.addEventListener('mouseleave', ()=>{
        video.pause();
        plane.material.color.set(0x92c0ea)
        plane.material.map = null;
        plane.material.needsUpdate = true;
      })

      

    }

    playOnHover(1, video_tableTennis);
    playOnHover(4, video_3dChess);

  


  }
  



  /**
   * Animate
   */
  const clock = new THREE.Clock();
  let lastElapsedTime = 0;
  
  const update = () => {
    const elapsedTime = clock.getElapsedTime();
    const deltaTime = elapsedTime - lastElapsedTime;
    lastElapsedTime = elapsedTime;
    
    
    if (mixer)
    mixer.update(deltaTime);
    
      // Update controls
      controls.update();
      
      // Render
      renderer.render(scene, camera);
      
      ui_renderer.render(scene, camera);
      
      // Call tick again on the next frame
      window.requestAnimationFrame(update);
      
    };
    

}




window.startLoading = ()=>{

  document.getElementsByClassName('cta')[0].style.display = "none";
  



  const elem = document.documentElement;
  /* View in fullscreen */
  const goFullscreen = ()=> {
    if(elem.requestFullscreen) 
      elem.requestFullscreen();
    else if (elem.webkitRequestFullscreen)  /* Safari */
      elem.webkitRequestFullscreen();
    else if (elem.msRequestFullscreen)  /* IE11 */
      elem.msRequestFullscreen();
  }
  
  goFullscreen();
  
  
  if (window.matchMedia(`(orientation: landscape)`).matches) {
    // you're in LANDSCAPE mode
    if(!scene_loaded)
      loadScene();  
  
    if(document.getElementsByClassName('scroll-container')[0])
      document.getElementsByClassName('scroll-container')[0].style.display = 'flex'; 
  
    document.getElementsByClassName('webgl')[0].style.display = 'block';
    document.getElementsByClassName('loading_screen')[0].style.display = 'block';
    document.getElementsByClassName('landscape_request')[0].style.display = 'none';
  } 
  else{
    
    if(document.getElementsByClassName('scroll-container')[0])
      document.getElementsByClassName('scroll-container')[0].style.display = 'none';
  
    document.getElementsByClassName('webgl')[0].style.display = 'none';
    document.getElementsByClassName('loading_screen')[0].style.display = 'none';
    document.getElementsByClassName('landscape_request')[0].style.display = 'flex';
    document.getElementsByClassName('phone')[0].style.display = "block";
    document.getElementsByClassName('message')[0].style.display = "block";
    document.body.style.backgroundColor = "black"; 
  }
  
  
  // Listen for orientation changes
  window.addEventListener("orientationchange", ()=> {
    
    
    if (window.matchMedia(`(orientation: portrait)`).matches) {
      // you're in LANDSCAPE mode
      if(!scene_loaded)
        loadScene();  
  
      if(document.getElementsByClassName('scroll-container')[0])
        document.getElementsByClassName('scroll-container')[0].style.display = 'flex'; 
  
      document.getElementsByClassName('webgl')[0].style.display = 'block';
      document.getElementsByClassName('loading_screen')[0].style.display = 'block';
      document.getElementsByClassName('landscape_request')[0].style.display = 'none';
    } 
    else{
      
      if(document.getElementsByClassName('scroll-container')[0])
        document.getElementsByClassName('scroll-container')[0].style.display = 'none';
  
      document.getElementsByClassName('webgl')[0].style.display = 'none';
      document.getElementsByClassName('loading_screen')[0].style.display = 'none';
      document.getElementsByClassName('landscape_request')[0].style.display = 'flex';
      document.getElementsByClassName('phone')[0].style.display = "block";
      document.getElementsByClassName('message')[0].style.display = "block";
      document.body.style.backgroundColor = "black"; 
    }
    
  }, false);

}



